export const documentNumberValidationMessage = {
    cannotStartWith0: 'El documento no puede iniciar por 0',
};
